var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2784_1640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.55026 16.8192L8.51826 3.1781C9.5304 3.77396 14.6341 6.59851 15.4584 7.13562L7.4904 20.7775C6.61895 21.9287 -0.55374 18.5662 0.55026 16.8184V16.8192Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4435 16.8189L15.4755 3.17864C14.3616 1.32485 11.9624 0.651194 9.99192 1.74609C8.02143 2.84099 7.42143 5.19961 8.53536 7.13616L16.5034 20.7781C17.6173 22.6311 20.0165 23.3047 21.9869 22.2098C23.8714 21.1149 24.5574 18.6727 23.4435 16.8206V16.8189Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99777 22.7371C6.20676 22.7371 7.99749 20.9908 7.99749 18.8367C7.99749 16.6826 6.20676 14.9363 3.99777 14.9363C1.78878 14.9363 -0.00195312 16.6826 -0.00195312 18.8367C-0.00195312 20.9908 1.78878 22.7371 3.99777 22.7371Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2784_1640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google-ads.523e80cec9d4cf08be001a847d2317d0.svg";
export { ForwardRef as ReactComponent };